import { get } from "lodash/fp";

export const projectChannelGuides = {
  fetchProjectChannelGuides: state =>
    get("projectChannelGuides.fetch.channelGuides")(state),
  selectProjectChannelGuide: state => get("projectChannelGuides.select")(state)
};
